module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-mobile-2fd0f10902ae63e30cd27cf960eb6e5b.webp";